<div [formGroup]="form">
    <div class="g-12 p-12:b md:p-16:b lg:p-24:b">
        <label
            for="password-input"
            appReactiveLabel
            formControlName="password"
            >Neues Passwort*:</label
        >
        <input
            id="password-input"
            type="password"
            class="m-6:b md:m-8:b lg:m-12:b"
            placeholder="Neues Passwort*"
            autocomplete="new-password"
            formControlName="password"
            (blur)="onTouched()"
            [ctrlErrorMessage]="passwordErrorMessages"
            required
        />
        <small
            [ngClass]="{ 'c:grey-4': changePWDisabled, 'c:grey-1': !changePWDisabled }"
            class="block"
            >Dein Passwort muss mindestens acht Zeichen lang sein und sollte Groß- wie Kleinbuchstaben, Ziffern und
            Sonderzeichen (z.B. %&$! usw.) enthalten.</small
        >
    </div>
    <div class="g-12">
        <label
            for="password-confirmation-input"
            appReactiveLabel
            formControlName="passwordAgain"
        >
            Neues Passwort (Wiederholung)*:
        </label>
        <input
            id="password-confirmation-input"
            type="password"
            class="m-6:b md:m-8:b lg:m-12:b"
            placeholder="Neues Passwort (Wiederholung)*"
            autocomplete="new-password"
            formControlName="passwordAgain"
            (blur)="onTouched()"
            [ctrlErrorMessage]="passwordAgainErrorMessages"
            required
        />
        <small
            [ngClass]="{ 'c:grey-4': changePWDisabled, 'c:grey-1': !changePWDisabled }"
            class="block"
        >
            Bitte wiederhole die Eingabe deines Passworts
        </small>
    </div>
</div>
